import { apiClient } from "lib/apiClient";
import { TMarketArea, TMarketAreaGeometry } from "features/MarketAreas/types";

export interface ICreateMarketAreaPayload {
  name: string;
  description: string | null;
  geometry: TMarketAreaGeometry;
}

export const createMarketArea = async (
  payload: ICreateMarketAreaPayload
): Promise<TMarketArea> => {
  const response = await apiClient.post<TMarketArea>("/market-areas", payload);

  return response.data;
};
